import { useContext } from "react";
import { AppContext, AppContextValue } from "./context";

const useAppContext = (): AppContextValue => {
  return useContext(AppContext);
};

export default useAppContext;
